/**
 * Special link targets that work anywhere in the theme (buttons, menus, rich text, announcement bar,
 * header promo badge):
 *
 *   #klaviyo-form-<FORM_ID>    opens that Klaviyo signup form as a popup (Klaviyo's openForm call)
 *   #omnisend-form-<FORM_ID>   opens that Omnisend popup / flyout form (Omnisend's openForm call)
 *
 * The form ID comes from the email app (Klaviyo: the 6-character code in the form's URL;
 * Omnisend: the form ID shown for custom triggers). If the app is not on the page, the click
 * does nothing: the call waits in the app's queue and never runs.
 * A link inside the mobile menu closes the menu first, so the popup is not hidden behind it.
 */
(function () {
  if (window.__momentumLinkActions) return;
  window.__momentumLinkActions = true;

  var APPS = {
    klaviyo: function (id) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', id]);
    },
    omnisend: function (id) {
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['openForm', id]);
    }
  };

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href*="-form-"]');
    if (!link) return;
    var match = (link.getAttribute('href') || '').match(/#(klaviyo|omnisend)-form-([A-Za-z0-9_-]+)/);
    if (!match) return;
    event.preventDefault();
    if (link.closest('.sub_header')) {
      var close = document.getElementById('menu_close');
      if (close) close.click();
    }
    APPS[match[1]](match[2]);
  });
})();
